"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _gridManager = _interopRequireDefault(require("../utils/gridManager/gridManager"));

var _constants = require("../utils/constants");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _keycode = _interopRequireDefault(require("keycode"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _table = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/table.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _table.default);
/** A **Table** is a set of tabular data. Line items can support `data`, `images` and `actions`. */

var Table = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames, _classnames3;

  var headers = _ref.headers,
      tableData = _ref.tableData,
      className = _ref.className,
      compact = _ref.compact,
      condensed = _ref.condensed,
      cssNamespace = _ref.cssNamespace,
      keyboardNavigation = _ref.keyboardNavigation,
      localizedText = _ref.localizedText,
      selection = _ref.selection,
      tableBodyClassName = _ref.tableBodyClassName,
      tableBodyProps = _ref.tableBodyProps,
      tableBodyRowProps = _ref.tableBodyRowProps,
      tableCellClassName = _ref.tableCellClassName,
      tableCheckboxClassName = _ref.tableCheckboxClassName,
      tableHeaderClassName = _ref.tableHeaderClassName,
      tableHeaderProps = _ref.tableHeaderProps,
      tableHeaderRowClassName = _ref.tableHeaderRowClassName,
      tableHeaderRowProps = _ref.tableHeaderRowProps,
      tableNavigationIconClassName = _ref.tableNavigationIconClassName,
      tableRowClassName = _ref.tableRowClassName,
      props = (0, _objectWithoutProperties2.default)(_ref, ["headers", "tableData", "className", "compact", "condensed", "cssNamespace", "keyboardNavigation", "localizedText", "selection", "tableBodyClassName", "tableBodyProps", "tableBodyRowProps", "tableCellClassName", "tableCheckboxClassName", "tableHeaderClassName", "tableHeaderProps", "tableHeaderRowClassName", "tableHeaderRowProps", "tableNavigationIconClassName", "tableRowClassName"]);
  var tableClasses = classnames("".concat(cssNamespace, "-table"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-table--compact"), compact), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-table--condensed"), condensed), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-table--no-horizontal-borders"), selection === null || selection === void 0 ? void 0 : selection.onClickRow), _classnames), className);
  var tableHeaderClasses = classnames("".concat(cssNamespace, "-table__header"), tableHeaderClassName);
  var tableHeaderRowClasses = classnames("".concat(cssNamespace, "-table__row"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-table__row--focusable"), keyboardNavigation === 'row'), tableHeaderRowClassName);
  var tableNavigationIconClasses = classnames("".concat(cssNamespace, "-table__icon"), "".concat(cssNamespace, "-table__icon--navigation"), tableNavigationIconClassName);
  var tableBodyClasses = classnames("".concat(cssNamespace, "-table__body"), tableBodyClassName);
  var tableRowClasses = classnames("".concat(cssNamespace, "-table__row"), (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-table__row--activable"), typeof (selection === null || selection === void 0 ? void 0 : selection.onClickRow) !== 'undefined'), (0, _defineProperty2.default)(_classnames3, "".concat(cssNamespace, "-table__row--focusable"), keyboardNavigation === 'row'), _classnames3), tableRowClassName);
  var tableCellClasses = classnames("".concat(cssNamespace, "-table__cell"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-table__cell--focusable"), keyboardNavigation === 'cell'), tableCellClassName);
  var tableCheckboxClasses = classnames("".concat(cssNamespace, "-table__cell"), "".concat(cssNamespace, "-table__cell--checkbox"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-table__cell--focusable"), keyboardNavigation === 'cell'), tableCheckboxClassName);
  var tableRefCallback = (0, _react.useCallback)(function (node) {
    if (node && keyboardNavigation !== 'none') {
      attachGridManager(node);
    }

    tableRef.current = node;
  }, []);

  var attachGridManager = function attachGridManager(node) {
    gridManager.current.attachTo({
      gridNode: node,
      onClickRow: onClickRowHandler,
      onFocusCell: onFocusCell,
      onKeyDownCell: onKeyDownCell,
      onToggleEditMode: onToggleEditMode,
      rowNavigation: keyboardNavigation === 'row'
    });
  };

  (0, _react.useEffect)(function () {
    if (keyboardNavigation === 'none') {
      gridManager.current.clearEvents();
    } else {
      attachGridManager(tableRef.current);
    }
  }, [keyboardNavigation]);
  var captionId = (0, _useUniqueId.default)();
  var gridManager = (0, _react.useRef)(new _gridManager.default());
  var tableRef = ref || (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      instructionsText = _useState2[0],
      setInstructionsText = _useState2[1];

  var onKeyDownCell = function onKeyDownCell(cell, event) {
    var key = event.which || event.keyCode;

    if (keyboardNavigation === 'row' && event.target.matches(_constants.GridSelector.ROW) && key === _keycode.default.codes.space) {
      selection.onSelectRow(cell.row - 1);
      event.preventDefault();
      return;
    }

    setInstructionsText(generateInstructionsText(cell, event));
  };

  var onClickRowHandler = function onClickRowHandler(cell) {
    (selection === null || selection === void 0 ? void 0 : selection.onClickRow) && selection.onClickRow(cell.row - 1);
  };

  var onToggleEditMode = function onToggleEditMode(enable) {
    setInstructionsText(enable ? localizedText.editModeDisable : '');
  };

  var onFocusCell = function onFocusCell(cell, event) {
    setInstructionsText(generateInstructionsText(cell, event));
  };

  var onBlurTable = function onBlurTable(event) {
    if (event.target === tableRef.current) {
      setInstructionsText('');
    }
  };

  var generateInstructionsText = function generateInstructionsText(cell, event) {
    var _gridManager$current, _gridManager$current2;

    if ((_gridManager$current = gridManager.current) === null || _gridManager$current === void 0 ? void 0 : _gridManager$current.editMode) {
      return localizedText.editModeDisable;
    }

    var newInstructionsText = '';

    switch (event.type) {
      case 'focus':
        if (instructionsText.length === 0) {
          if (keyboardNavigation !== 'row') {
            newInstructionsText += "".concat(localizedText.arrowKeys, " ");
          } else {
            newInstructionsText += "".concat(localizedText.rowInstructions);
          }
        }

        break;

      default:
        break;
    }

    if (((_gridManager$current2 = gridManager.current) === null || _gridManager$current2 === void 0 ? void 0 : _gridManager$current2.isEditableCell(cell)) && keyboardNavigation === 'cell') {
      newInstructionsText += localizedText.editModeEnable;
    }

    return newInstructionsText;
  };

  var checkboxHeader;
  var displayHeaders = (0, _toConsumableArray2.default)(headers);
  var navigationHeader;

  if (selection) {
    checkboxHeader = /*#__PURE__*/_react.default.createElement("th", {
      className: tableCheckboxClasses
    }, headers[0]);
    displayHeaders = (0, _splice.default)(displayHeaders).call(displayHeaders, 1, headers.length);

    if (selection.onClickRow) {
      navigationHeader = /*#__PURE__*/_react.default.createElement("th", {
        className: tableCellClasses
      });
    }
  }

  var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: tableNavigationIconClasses,
    glyph: "navigation-right-arrow"
  });

  return /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, props, {
    "aria-describedby": captionId,
    className: tableClasses,
    onBlur: onBlurTable,
    ref: tableRefCallback,
    role: keyboardNavigation ? 'grid' : 'table'
  }), /*#__PURE__*/_react.default.createElement("caption", {
    "aria-live": "polite",
    className: classnames("".concat(cssNamespace, "-table__caption")),
    id: captionId
  }, instructionsText), /*#__PURE__*/_react.default.createElement("thead", (0, _extends2.default)({
    className: tableHeaderClasses
  }, tableHeaderProps), /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
    className: tableHeaderRowClasses
  }, tableHeaderRowProps), selection && checkboxHeader, (0, _map.default)(displayHeaders).call(displayHeaders, function (header, index) {
    return /*#__PURE__*/_react.default.createElement("th", {
      className: tableCellClasses,
      key: index
    }, header);
  }), (selection === null || selection === void 0 ? void 0 : selection.onClickRow) && navigationHeader)), /*#__PURE__*/_react.default.createElement("tbody", (0, _extends2.default)({
    className: tableBodyClasses
  }, tableBodyProps), (0, _map.default)(tableData).call(tableData, function (row, index) {
    var rowProps, checkboxCell, navigationCell;
    var displayCells = (0, _toConsumableArray2.default)(row.rowData);

    if (tableBodyRowProps) {
      rowProps = typeof tableBodyRowProps === 'function' ? tableBodyRowProps(row, index) : tableBodyRowProps;
    }

    if (selection) {
      checkboxCell = /*#__PURE__*/_react.default.createElement("td", {
        className: tableCheckboxClasses
      }, row.rowData[0]);
      displayCells = (0, _splice.default)(displayCells).call(displayCells, 1, row.rowData.length);

      if (selection.onClickRow) {
        navigationCell = /*#__PURE__*/_react.default.createElement("td", {
          className: classnames(tableCellClasses, "".concat(cssNamespace, "-table__cell--fit-content"), "".concat(cssNamespace, "-table__cell----no-padding"))
        }, _ref2);
      }
    }

    return /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
      className: tableRowClasses
    }, rowProps, {
      "aria-selected": selection === null || selection === void 0 ? void 0 : selection.isSelected(index),
      key: index,
      onClick: function onClick(event) {
        var _context, _context2;

        if (event.target.matches((0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(_constants.GridSelector.CELL, ", ")).call(_context2, _constants.GridSelector.ROW, ", .")).call(_context, cssNamespace, "-table__icon--navigation"))) {
          (selection === null || selection === void 0 ? void 0 : selection.onClickRow) && selection.onClickRow(index);
        }
      }
    }), selection && checkboxCell, (0, _map.default)(displayCells).call(displayCells, function (cellData, cellIndex) {
      var _cellData$type, _cellData$type$propTy;

      if ((_cellData$type = cellData.type) === null || _cellData$type === void 0 ? void 0 : (_cellData$type$propTy = _cellData$type.propTypes) === null || _cellData$type$propTy === void 0 ? void 0 : _cellData$type$propTy.compact) {
        cellData = /*#__PURE__*/_react.default.cloneElement(cellData, {
          compact: compact || condensed
        });
      }

      return /*#__PURE__*/_react.default.createElement("td", {
        className: tableCellClasses,
        key: cellIndex
      }, cellData);
    }), (selection === null || selection === void 0 ? void 0 : selection.onClickRow) && navigationCell);
  })));
});

Table.displayName = 'Table';
process.env.NODE_ENV !== "production" ? Table.propTypes = {
  /** Array of localized text strings for the column headers */
  headers: _propTypes.default.array.isRequired,

  /** Array of objects that contain one property: `rowData` (an array of nodes containing data for each column in the row) */
  tableData: _propTypes.default.arrayOf(_propTypes.default.shape({
    rowData: _propTypes.default.array
  }).isRequired).isRequired,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to enable condensed mode */
  condensed: _propTypes.default.bool,

  /** Determines the type of keyboard navigation for the table. Set to `'cell'` for cell-level navigation or `'row'` for row-level navigation */
  keyboardNavigation: _propTypes.default.oneOf(['none', 'cell', 'row']),

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** Localized string informing screen reader users the table can be navigated by arrow keys */
    arrowKeys: _propTypes.default.string,

    /** Localized string informing screen reader users the current cell can be edited  */
    editModeEnable: _propTypes.default.string,

    /** Localized string informing screen reader users how to return to cell navigation */
    editModeDisable: _propTypes.default.string,

    /** Localized string informing screen reader users how to interact with rows. Please ensure the instructions are consistent with the provided default. */
    rowInstructions: _propTypes.default.string
  }),

  /** Props related to row selection */
  selection: _propTypes.default.shape({
    /** Callback function; triggered when a row is clicked or the Enter key is pressed during row navigation
     * @param {number} index - Index of the row being selected, or -1 for the header row.
     * @returns {void}
     */
    onClickRow: _propTypes.default.func,

    /** Determines whether a row should be selected
     * @param {number} index - Index of the row being selected, or -1 for the header row.
     * @returns {boolean}
     */
    isSelected: _propTypes.default.func,

    /** Callback function; triggered when a row is selected
     * @param {number} index - Index of the row being selected, or -1 for the header row.
     * @returns {void}
     */
    onSelectRow: _propTypes.default.func
  }),

  /** Additional classes to be added to the `<tbody>` element */
  tableBodyClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<tbody>` element */
  tableBodyProps: _propTypes.default.object,

  /** Additional props to be spread to the `<tr>` elements within `<tbody>`.
   * If using a function, the parameters passed will be an object representing the row (from `tableData`) and the row index */
  tableBodyRowProps: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /** Additional classes to be added to the `<td>` elements */
  tableCellClassName: _propTypes.default.string,

  /** Additional classes to be added to the Checkbox in a rich table */
  tableCheckboxClassName: _propTypes.default.string,

  /** Additional classes to be added to the `<thead>` element */
  tableHeaderClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<thead>` element */
  tableHeaderProps: _propTypes.default.object,

  /** Additional classes to the `<tr>` element within `<thead>` */
  tableHeaderRowClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<tr>` element within `<thead>` */
  tableHeaderRowProps: _propTypes.default.object,

  /** Additional classes to be added to the navigation icon in navigable rows */
  tableNavigationIconClassName: _propTypes.default.object,

  /** Additional classes to be added to the `<tr>` elements */
  tableRowClassName: _propTypes.default.string
} : void 0;
Table.defaultProps = {
  keyboardNavigation: 'none',
  localizedText: {
    arrowKeys: 'Use arrow keys to navigate between cells',
    editModeEnable: 'Press Enter to edit this cell',
    editModeDisable: 'Press Escape to return to cell navigation',
    rowInstructions: 'Use up and down keys to navigate between rows, press Enter to click a row, and press Space to select a row'
  }
};

var _default = (0, _withStyles.default)(Table);

exports.default = _default;